import  { useState, memo, FunctionComponent } from 'react';
import { useInterval } from 'react-use';

import dayjs from 'dayjs';

interface FormatDateProps {
  getDateEnd: string;
}

const FormatDate: FunctionComponent<FormatDateProps> = ({ getDateEnd }) => {
  const [time, setTime] = useState(null);

  useInterval(() => {
    setTime(() => {
      const date = dayjs(getDateEnd);

      let hours: any = date.diff(dayjs(), 'hours');

      if (hours < 10) {
        hours = `0${hours}`;
      }

      let minutes: any = date.diff(dayjs(), 'minutes') % 60;

      if (minutes < 10) {
        minutes = `0${minutes}`;
      }

      let seconds: any = date.diff(dayjs(), 'seconds') % 60;

      if (seconds < 0) {
        return undefined;
      }

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return {
        hours,
        minutes,
        seconds,
      };
    });
  }, 1000);

  return (
    <div
      className="case-free-timer"
      style={{ visibility: time?.seconds ? 'unset' : 'hidden' }}
    >
      <div className="hours">{time?.hours}</div>
      <div className="separ">:</div>
      <div className="minuts">{time?.minutes}</div>
      <div className="separ">:</div>
      <div className="seconds">{time?.seconds}</div>
    </div>
  );
};

export default memo(FormatDate);
